export const CHAIN_MAINNET = 'mainnet'
export const CHAIN_TESTNET = 'testnet'

export const ALGO_ASSET_ID = 0
export const ALGO_ZERO_ADDRESS = 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY5HFKQ'

// ORDER ROUTER
export const TYPE_FIXED_INPUT = 'fixed-input'
export const TYPE_FIXED_OUTPUT = 'fixed-output'
export const FETCH_QUOTE_API = 'fetchQuote'
export const FETCH_EXECUTE_SWAP_TXNS_API = 'fetchExecuteSwapTxns'
export const ORDER_ROUTER_DEFAULT_FEE_BPS = 22
export const DEFAULT_MAX_GROUP_SIZE = 16

export const DEFLEX_FIXED_FEE_TXN_NOTE = 'deflex-fixed-fee'

export const PROTOCOL_VERSION_0 = 0;
export const PROTOCOL_VERSION_1 = 1;

export const LEGACY_ORDER_ROUTER_APP_IDS = {
    [CHAIN_MAINNET]: 951874839,
    [CHAIN_TESTNET]: 127511496,
}

export const DEFLEX_MANAGER_ADDRESS = '5ENOS6PIT4LKLUKO4OMVKXDBLZ3VN2YQ3MQBMGY73JSYLRBHKJIBAIEZHY'
export const TREASURY_ADDRESS = 'R6KP6FOKGJM6I53EIJESWNCZBYS3UO4EY56SF3LZXFTNJBXIOAP7LEGCBQ'

// LIMIT ORDERS (disabled in protocol at the moment !)
export const PROTOCOL_TREASURY_APP_IDS = {
    [CHAIN_MAINNET]: 949203488,
    [CHAIN_TESTNET]: 123803250,
}

export const REGISTRY_APP_IDS_BY_VERSION = {
    [CHAIN_MAINNET]: {
        [PROTOCOL_VERSION_0]: 949209670,
        [PROTOCOL_VERSION_1]: 1147114926
    },
    [CHAIN_TESTNET]: {
        [PROTOCOL_VERSION_0]: 123803795,
        [PROTOCOL_VERSION_1]: 257192861
    },
}
export const LIMIT_ORDER_MIN_FEE_BPS = 6
